export default __webpack_public_path__ + "static/media/caret.9e5e8ccc.svg";